// src/pages/EmpecemosPage.jsx
import * as React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Stack,
  Divider,
  IconButton,
  InputAdornment,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import { motion } from "framer-motion";
import { useLead } from "../context/LeadContext"; // ⬅️ nuevo

export default function EmpecemosPage() {
  const { leadName, setLeadName } = useLead(); // ⬅️ lee/persist
  const [name, setName] = React.useState(leadName || "");
  const [touched, setTouched] = React.useState(false);
  const [step, setStep] = React.useState(leadName ? "form" : "ask-name"); // ⬅️ si había nombre, ir al form

  const nameOk = name.trim().length >= 2;

  // cuando el usuario escribe, actualizamos state y context (persistencia)
  const handleNameChange = (e) => {
    const v = e.target.value;
    setName(v);
    setLeadName(v); // ⬅️ persiste
  };

  const goToForm = () => {
    setTouched(true);
    if (nameOk) setStep("form");
  };

  const BRAND = {
    primary: "#F35A3A",
    dark: "#19242F",
    lightBG: "#fff",
  };

  const fadeUp = {
    initial: { opacity: 0, y: 12 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.38, ease: "easeOut" },
    },
  };
  const fade = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.38 } },
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      goToForm();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const payload = Object.fromEntries(data.entries());
    payload.nombre = name.trim();
    console.log("Empecemos payload:", payload);
    // TODO: enviar a tu backend
  };
const FORM_CARD_SX = {
  position: "relative",
  p: { xs: 3, md: 4 },
  borderRadius: 12,
  // borde degradado sin pseudo-elemento (sin artefactos en esquinas)
  border: "1px solid transparent",
  background:
    "linear-gradient(#fff, #fff) padding-box, " +
    "linear-gradient(135deg, rgba(243,90,58,.35), rgba(25,36,47,.15)) border-box",
  boxShadow: "0 20px 50px rgba(0,0,0,.08)",
  overflow: "hidden",

  // “glow” superior muy leve (mantenemos el ::after)
  "&::after": {
    content: '""',
    position: "absolute",
    top: -80,
    left: -80,
    width: 240,
    height: 240,
    borderRadius: "50%",
    background:
      "radial-gradient(closest-side, rgba(243,90,58,.08), transparent)",
    pointerEvents: "none",
  },
};
  const FIELD_SX = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#fff",
    },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(25,36,47,.22)" },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(25,36,47,.45)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F35A3A",
      borderWidth: 2,
      boxShadow: "0 0 0 3px rgba(243,90,58,.12)",
    },
  };

  return (
    <Box sx={{ bgcolor: BRAND.lightBG, minHeight: "100vh", pb: 10 }}>
      {/* HERO */}
      <Box
        component={motion.div}
        variants={fade}
        initial="initial"
        animate="animate"
        sx={{
          py: 9,
          background:
            "radial-gradient(90rem 40rem at 50% -20%, rgba(243,90,58,.12), #fff 55%)",
        }}
      >
        <Container
          sx={{ textAlign: "center", maxWidth: { xs: "95vw", md: "70vw" } }}
        >
          {step === "ask-name" ? (
            <Typography
              sx={{
                fontSize: { xs: "2rem", md: "4rem" },
                fontWeight: 900,
                color: BRAND.dark,
                letterSpacing: "-.02em",
              }}
            >
              Empecemos,{" "}
              <Box component="span" sx={{ color: BRAND.primary }}>
                ¿como te llamas?
              </Box>
            </Typography>
          ) : (
            <Typography
              component={motion.h1}
              variants={fadeUp}
              initial="initial"
              animate="animate"
              sx={{
                fontWeight: 900,
                color: BRAND.dark,
                letterSpacing: "-.02em",
                fontSize: {
                  xs: "clamp(2rem, 7vw, 3rem)",
                  md: "clamp(2.8rem, 4vw, 3.2rem)",
                },
              }}
            >
              {name.trim()}, ¡bienvenido a{"  "}
              <Box component="span" sx={{ color: BRAND.primary }}>
                Webprofit
              </Box>
            </Typography>
          )}

          <Typography
            component={motion.p}
            variants={fadeUp}
            initial="initial"
            animate="animate"
            color="text.secondary"
            sx={{ mt: 1.4, fontSize: { xs: "1.2rem", md: "1.8rem" } }}
          >
            {step === "ask-name"
              ? "Danos tu nombre para empezar"
              : "Completá el formulario y te escribimos enseguida."}
          </Typography>
        </Container>
      </Box>

      {/* STEP 1: nombre a pantalla con un solo textfield */}
      {step === "ask-name" && (
        <Container
          maxWidth="md"
          component={motion.div}
          variants={fadeUp}
          initial="initial"
          animate="animate"
        >
          <Box
            sx={{
              minHeight: { xs: "36vh", md: "20vh" },
              display: "grid",
              placeItems: "center",
            }}
          >
            <TextField
              autoFocus
              fullWidth
              placeholder="Ej: Néstor"
              label="TU NOMBRE"
              value={name}
              onChange={handleNameChange}
              onBlur={() => setTouched(true)}
              onKeyDown={handleKeyDown}
              error={touched && !nameOk}
              helperText={
                touched && !nameOk ? "Ingresá al menos 2 caracteres." : " "
              }
              sx={{
                maxWidth: 520,
                // input más “píldora”, sin espacio a la derecha
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  pr: 0, // 👈 sin padding a la derecha para que el botón quede al borde
                  color: BRAND.dark,
                  backgroundColor: "#fff",
                },
                // borde negro SIEMPRE (normal, hover, focus y con error)
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: BRAND.dark,
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: BRAND.dark,
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: BRAND.dark,
                    borderWidth: 2,
                  },
                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: BRAND.dark,
                  },
                // label y texto negros
                "& .MuiInputLabel-root": { color: BRAND.dark },
                "& .MuiInputLabel-root.Mui-focused": { color: BRAND.dark },
                "& .MuiInputBase-input": { color: BRAND.dark },

                // el adornment (contenedor del botón) sin márgenes
                "& .MuiInputAdornment-root": { m: 0 },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ m: 0 }}>
                    <IconButton
                      aria-label="Continuar"
                      onClick={goToForm}
                      edge="end"
                      sx={{
                        background: "linear-gradient(90deg, #FF5733, #FF8A5C)",
                        color: "#fff",
                        borderRadius: "0 12px 12px 0", // 👈 se “fusiona” con el input
                        width: 48,
                        height: 54,
                        m: 0,
                        "&:hover": { bgcolor: "#e24f32" },
                        // compacta el hit-area con el borde del input
                        boxShadow: "none",
                      }}
                    >
                      <ArrowForwardRounded />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Container>
      )}

      {/* STEP 2: formulario completo */}
      {step === "form" && (
        <Container
          maxWidth="md"
          sx={{ px: { xs: 2, md: 3 } }}
          component={motion.div}
          variants={fadeUp}
          initial="initial"
          animate="animate"
        >
          <Paper elevation={0} sx={FORM_CARD_SX}>
            {/* mini header dentro de la card */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2.5,
              }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "#F35A3A",
                  boxShadow: "0 0 0 4px rgba(243,90,58,.15)",
                }}
              />
              <Typography
                variant="overline"
                sx={{
                  letterSpacing: ".12em",
                  color: "text.secondary",
                  fontWeight: 800,
                }}
              >
                FORMULARIO
              </Typography>
              <Box sx={{ ml: "auto" }}>
                <Typography sx={{ fontWeight: 800, color: "text.secondary" }}>
                  Hola {name.trim()} 👋
                </Typography>
              </Box>
            </Box>

            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2.2}>
                <Typography sx={{ fontWeight: 800, mb: 0.5 }}>
                  {name.trim()}, completá tus datos
                </Typography>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    type="email"
                    name="email"
                    label="Email"
                    required
                    sx={FIELD_SX}
                  />
                  <TextField
                    fullWidth
                    name="telefono"
                    label="Teléfono / WhatsApp"
                    required
                    sx={FIELD_SX}
                  />
                </Stack>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    name="empresa"
                    label="Empresa (opcional)"
                    sx={FIELD_SX}
                  />
                  <TextField
                    fullWidth
                    name="instagram"
                    label="Instagram (opcional)"
                    placeholder="@tu_cuenta"
                    sx={FIELD_SX}
                  />
                </Stack>

                <TextField
                  fullWidth
                  name="mensaje"
                  label="Mensaje (opcional)"
                  placeholder="Contanos brevemente tu necesidad"
                  multiline
                  minRows={4}
                  sx={FIELD_SX}
                />

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ pt: 1 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      fontWeight: 900,
                      borderRadius: 1,
                      boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                      background:
                        "linear-gradient(90deg, #F35A3A 65%, #FF8A5C)",
                      transition:
                        "transform .25s ease, box-shadow .25s ease, background-color .25s ease",
                      ":hover": {
                        transform: "scale(1.05)",
                        background: "#0f1821",
                      },
                    }}
                  >
                    Enviar consulta
                  </Button>

                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<WhatsAppIcon />}
                    href={`https://wa.me/5491112345678?text=Hola%20${encodeURIComponent(
                      name.trim() || ""
                    )}%2C%20quiero%20empezar%20un%20proyecto`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      fontWeight: 900,
                      bgcolor: BRAND.dark,
                      color: "#FFF",
                      borderRadius: 1,
                      boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                      transition:
                        "transform .25s ease, box-shadow .25s ease, background-color .25s ease, color .25s ease",
                      "& .MuiButton-startIcon > *": {
                        color: "#25D366",
                        transition: "color .25s ease",
                      },
                      "&:hover": {
                        transform: "scale(1.05)",
                        bgcolor: "#25D366",
                        color: "#fff",
                        boxShadow: "0 10px 22px rgba(37, 211, 102, 0.35)",
                      },
                      "&:hover .MuiButton-startIcon > *": { color: "#fff" },
                    }}
                  >
                    Hablar por WhatsApp
                  </Button>
                </Stack>
              </Stack>

              <Divider sx={{ my: 3 }} />

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={3}
                divider={<Divider flexItem orientation="vertical" />}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 800, mb: 0.5 }}>
                    ¿Cuánto demora?
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Landing: 5–10 días. Sitio completo: 2–4 semanas. Soluciones
                    a medida: por hitos.
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 800, mb: 0.5 }}>
                    ¿Qué incluye?
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Diseño responsive, performance base, SEO técnico inicial y
                    handoff simple.
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 800, mb: 0.5 }}>
                    ¿Cómo seguimos?
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Te escribimos para coordinar una llamada de 15′ y validar
                    alcance.
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Paper>
        </Container>
      )}
    </Box>
  );
}
